import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const baseStyles = {
    container: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'relative',
        zIndex: 0
    },
    volumeBarsContainer: {
        flexDirection: 'row',
        justifyContent: 'center',
        marginHorizontal: 20
    },
    volumeBarContainer: {
        height: 36,
        width: 16
    },
    volumeBar: {
        height: 36,
        width: 6,
        marginHorizontal: 5,
        backgroundColor: Theme.primaryTextColor
    },
    filledVolumeBar: {
        backgroundColor: Theme.primaryActiveColor
    }
};

export default StyleSheet.create(baseStyles);
